module.exports = __webpack_public_path__ + "img/contact-mobile-banner.e0fd8e81.png";